import { useMutation, useQueryClient } from 'react-query';
import { deleteCommentService } from '../redux/services/postService';
import HookTypes from '../redux/types/hooks';

type Mutation = {
  commentId: string;
  id: string;
};

export default function mutation() {
  const client = useQueryClient();

  return useMutation(
    async (mutation: Mutation) => {
      await deleteCommentService(mutation.commentId, mutation.id);
    },
    {
      onSuccess: async () => {
        await client.invalidateQueries([HookTypes.activity, HookTypes.post]);
        await client.refetchQueries();
      },
    }
  );
}
